import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.from-entries.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
/// === IMPORTS === ///
/// --- External --- ///
import React from "react";
import { httpsCallable } from "firebase/functions"; /// --- Internal --- ///
import FirebaseHandler from "../services/firebase";
import AuthContext from "../services/firebase/auth-context/provider";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { toEuroString } from "../util/format/euro";
import "../styles/webshop.css";
import { useAnalytics } from "../hooks/use-ga";
/* === ---------------------------------------------------------------------------------------------------------- === */
/* === ----------------------------------------------- EDIT BELOW ----------------------------------------------- === */
var DICT_BOOK = {
    'groh-2023': {
        author: "Armin Groh",
        title: "Die blinden Flecken der Demokratie",
        subtitle: "Eine Entdeckungsreise in die politische Ideengeschichte",
        details: "Promedia 2023. 264 S. 10,7 x 17,5. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1695805145-f12ba1cee7fa2f18b77cd1860e3b2aa5.jpeg",
        print_isbn: "978-3-85371-522-2",
        ebook_isbn: "978-3-85371-912-1",
        print_price: 23.00,
        ebook_price: 17.99,
        is_print: true,
        is_ebook: true
    },
    'reiners-2023': {
        author: "Hartmut Reiners",
        title: "Die ökonomische Vernunft der Solidarität",
        subtitle: "Perspektiven einer demokratischen Sozialpolitik",
        details: "Promedia 2023. ca. 224 S. 14,8 x 21. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1700484945-cover-02-reiners.jpg",
        print_isbn: "978-3-85371-516-1",
        ebook_isbn: "978-3-85371-909-1",
        print_price: 22.00,
        ebook_price: 18.99,
        is_print: true,
        is_ebook: true
    },
    'king-2022': {
        author: "John E. King",
        title: "Postkeynesianismus",
        subtitle: "Eine Einführung",
        details: "Promedia 2022. 240 S. 10,7 x 17,5. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1664292852-cover-postkeynesianismus.jpg",
        print_isbn: "978-3-85371-506-2",
        ebook_isbn: "978-3-85371-902-2",
        print_price: 22.00,
        ebook_price: 17.99,
        is_print: true,
        is_ebook: true
    },
    'keen-2024': {
        author: "Steve Keen",
        title: "Für eine Neue Ökonomik",
        subtitle: "Ein Manifest",
        details: "Promedia 2024. 176 S. 14,8 x 21. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1734620511-cover.jpg",
        print_isbn: "978-3-85371-538-3",
        ebook_isbn: "978-3-85371-924-4",
        print_price: 22.00,
        ebook_price: 17.99,
        is_print: true,
        is_ebook: true
    },
    'land-2025': {
        author: "Rainer Land",
        title: "Chinas gelenkte Marktwirtschaft",
        subtitle: "Hintergrüde eines Booms",
        details: "Promedia 2025. 240 S. 14,8 x 21. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1740044736-chinas-gelenkte-marktwirtschaft.jpg",
        print_isbn: "978-3-85371-545-1",
        ebook_isbn: "978-3-85371-930-5",
        print_price: 23.00,
        ebook_price: 18.99,
        is_print: true,
        is_ebook: true
    },
    'mitchell-2025': {
        author: "William Mitchell & Thomas Fazi",
        title: "Wie wir den Staat zurückgewinnen. Souveränität in einer Welt nach dem Neoliberalismus.",
        subtitle: "Aus dem Englischen von Ulrike Simon",
        details: "Promedia 2025. 280 S. 14,8 x 21. brosch.",
        src_image: "https://www.datocms-assets.com/19658/1759846439-wie-wir-den-staat-zurueckgewinnen.jpg",
        print_isbn: "978-3-85371-552-9",
        ebook_isbn: "978-3-85371-935-0",
        print_price: 25.00,
        ebook_price: 19.99,
        is_print: true,
        is_ebook: true
    },
    'spatz-2026': {
        author: "Alexander Mosca Spatz",
        title: "Woran Wirtschaftspolitik scheitert",
        subtitle: "Über Märkte, Hierarchien und Ungleichheit",
        details: "Promedia 2026. ca. 256 S. 14,8 x 21. brosch.",
        src_image: "/books/spatz-2026.jpg",
        print_isbn: "978-3-85371-565-9",
        ebook_isbn: "978-3-85371-946-6",
        print_price: 24.00,
        ebook_price: 19.99,
        is_print: true,
        is_ebook: true,
        print_available: true,
        ebook_available: true,
        sort_order: -1
    }
};
/* === ----------------------------------------------- EDIT ABOVE ----------------------------------------------- === */
/* === ---------------------------------------------------------------------------------------------------------- === */
/// === FIREBASE FUNCTIONS === ///
export var getArticles = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt("return", httpsCallable(FirebaseHandler.functions, "getArticles")());
                    case 1:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function getArticles() {
        return _ref.apply(this, arguments);
    };
}();
export var getAccount = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt("return", httpsCallable(FirebaseHandler.functions, "accountOverview")());
                    case 1:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2);
    }));
    return function getAccount() {
        return _ref2.apply(this, arguments);
    };
}(); /// === TYPE / INTERFACE / CLASS DEFINITIONS === ///
var PRODUCT = /*#__PURE__*/ function () {
    // -- Properties -- //
    // -- Constructor -- //
    function PRODUCT(article) {
        var _article$id, _article$src_image, _article$sort_order;
        // - Property Passing - //
        this.ID = (_article$id = article.id) !== null && _article$id !== void 0 ? _article$id : article.article_number;
        this.Code = article.article_number;
        this.Title = article.title;
        this.URL_Checkout = article.checkout_url;
        this.Subtitle = article.subtitle;
        this.Author = article.author;
        this.Description = article.description;
        this.ISBN = article.isbn;
        this.SRC_Image = (_article$src_image = article.src_image) !== null && _article$src_image !== void 0 ? _article$src_image : 'https://community.softr.io/uploads/db9110/original/2X/7/74e6e7e382d0ff5d7773ca9a87e6f6f8817a68a6.jpeg';
        this.Unit_Price = article.unit_price;
        this.VAT_Percent = article.vat_percent > 0 ? article.vat_percent : 0;
        this.Is_Addon = article.is_addon;
        this.Is_Brutto = article.is_gross;
        this.Is_Digital = article.is_digital;
        this.Is_Available = article.is_available !== false;
        this.Sort_Order = (_article$sort_order = article.sort_order) !== null && _article$sort_order !== void 0 ? _article$sort_order : 0;
        this.List_Article_Code = article.assigned_articles;
    } // -- Methods -- //
    _createClass(PRODUCT, [{
            key: "Vendor_Hash",
            get: function get() {
                return this.URL_Checkout.split('/').slice(-2)[0];
            }
        }, {
            key: "Brutto_Price",
            get: function get() {
                return this.Unit_Price * (1 + (this.Is_Brutto ? 0 : this.VAT_Percent / 100));
            }
        }]);
    return PRODUCT;
}();
/// === CONFIG & CACHE === ///
var USE_LIVE_DATA = false;
var MONSUM_CHECKOUT = 'https://app.monsum.com/purchase/4460bb04b8e54b22c4ed9b836eca00e5';
var BOOK_ARTICLE_NUMBER = 'BOOK';
var MONSUM_CACHE_ARTICLE = [{
        article_number: BOOK_ARTICLE_NUMBER,
        title: "Edition MAKROSKOP online bestellen",
        author: "",
        description: "",
        isbn: "",
        unit_price: 0.00,
        vat_percent: 7,
        is_gross: false,
        is_addon: false,
        is_digital: false,
        checkout_url: MONSUM_CHECKOUT + "/" + BOOK_ARTICLE_NUMBER,
        assigned_articles: []
    }].map(function (product) {
    return new PRODUCT(product);
});
var MONSUM_CACHE_BOOK = Object.entries(DICT_BOOK).flatMap(function (_ref3) {
    var code = _ref3[0], book = _ref3[1];
    return [book.is_print ? {
            id: code,
            article_number: BOOK_ARTICLE_NUMBER + "-print-" + code,
            checkout_url: MONSUM_CHECKOUT + "/" + BOOK_ARTICLE_NUMBER + "-print-" + code,
            title: book.title,
            subtitle: book.subtitle,
            author: book.author,
            isbn: book.print_isbn,
            description: book.details,
            src_image: book.src_image,
            unit_price: book.print_price,
            vat_percent: 7,
            is_gross: true,
            is_addon: true,
            is_digital: false,
            is_available: book.print_available !== false,
            sort_order: book.sort_order,
            assigned_articles: [BOOK_ARTICLE_NUMBER]
        } : undefined, book.is_ebook ? {
            id: code,
            article_number: BOOK_ARTICLE_NUMBER + "-ebook-" + code,
            checkout_url: MONSUM_CHECKOUT + "/" + BOOK_ARTICLE_NUMBER + "-ebook-" + code,
            title: book.title,
            subtitle: book.subtitle,
            author: book.author,
            isbn: book.ebook_isbn,
            description: book.details,
            src_image: book.src_image,
            unit_price: book.ebook_price,
            vat_percent: 7,
            is_gross: true,
            is_addon: true,
            is_digital: true,
            is_available: book.ebook_available !== false,
            sort_order: book.sort_order,
            assigned_articles: [BOOK_ARTICLE_NUMBER]
        } : undefined].filter(function (product) {
        return product != undefined;
    }).map(function (product) {
        return new PRODUCT(product);
    });
});
var MONSUM_CACHE = [].concat(_toConsumableArray(MONSUM_CACHE_ARTICLE), _toConsumableArray(MONSUM_CACHE_BOOK)); /// === COMPONENT DEFINITION === ///
var Comp_Product = function Comp_Product(_ref4) {
    var Product = _ref4.Product, fxn_click = _ref4.fxn_click, Is_ListItem = _ref4.Is_ListItem;
    // - Render - //
    var svg_print = /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    }));
    var svg_ebook = /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z"
    }));
    var render_product = function render_product(is_clickable) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Title"
        }, Product.Title), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Subtitle"
        }, Product.Subtitle), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Author"
        }, Product.Author), /*#__PURE__*/ React.createElement("img", {
            className: "PRODUCT_Image",
            alt: Product.Title,
            src: Product.SRC_Image,
            onClick: function onClick() {
                return is_clickable && fxn_click ? fxn_click(Product) : function () { };
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Price"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "PRODUCT_Type",
            title: Product.Is_Digital ? 'E-Book' : 'Print'
        }, Product.Is_Digital ? svg_ebook : svg_print), /*#__PURE__*/ React.createElement("span", {
            className: "PRODUCT_Cost"
        }, toEuroString(Product.Brutto_Price))));
    };
    return Is_ListItem ? /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT SINGLETON"
    }, render_product(false), /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT_Trash",
        onClick: function onClick() {
            return fxn_click ? fxn_click(Product) : function () { }();
        }
    }, "x")) : render_product(true);
};
var Comp_Product_Pair = function Comp_Product_Pair(_ref5) {
    var _Product_Print$Brutto, _Product_Ebook$Brutto;
    var Product_Print = _ref5.Product_Print, Product_Ebook = _ref5.Product_Ebook, fxn_click = _ref5.fxn_click, Is_ListItem = _ref5.Is_ListItem;
    // - Initialization - //
    var svg_print = /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    }));
    var svg_ebook = /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64L64 64l0 320 320 0 0-320z"
    }));
    var is_singleton = !(Product_Print && Product_Ebook);
    var product_base = !Product_Print && Product_Ebook ? Product_Ebook : Product_Print; // - Render - //
    var render_product_same = function render_product_same(is_clickable) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Title"
        }, product_base.Title), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Subtitle"
        }, product_base.Subtitle), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Author"
        }, product_base.Author), /*#__PURE__*/ React.createElement("img", {
            className: "PRODUCT_Image",
            alt: product_base.Title,
            src: product_base.SRC_Image,
            onClick: function onClick() {
                return is_clickable && fxn_click ? fxn_click(product_base) : function () { };
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "PRODUCT_Description"
        }, product_base.Description));
    };
    var render_product_print = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT_Price PRINT"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "PRODUCT_Type",
        title: "Print"
    }, svg_print), /*#__PURE__*/ React.createElement("span", {
        className: "PRODUCT_Cost"
    }, toEuroString((_Product_Print$Brutto = Product_Print === null || Product_Print === void 0 ? void 0 : Product_Print.Brutto_Price) !== null && _Product_Print$Brutto !== void 0 ? _Product_Print$Brutto : 0))), /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT_ISBN PRINT"
    }, "ISBN: ", Product_Print.ISBN));
    var render_product_ebook = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT_Price EBOOK"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "PRODUCT_Type",
        title: "E-Book"
    }, svg_ebook), /*#__PURE__*/ React.createElement("span", {
        className: "PRODUCT_Cost"
    }, toEuroString((_Product_Ebook$Brutto = Product_Ebook === null || Product_Ebook === void 0 ? void 0 : Product_Ebook.Brutto_Price) !== null && _Product_Ebook$Brutto !== void 0 ? _Product_Ebook$Brutto : 0))), /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT_ISBN EBOOK"
    }, "ISBN: ", Product_Ebook.ISBN));
    var render_product = function render_product(is_clickable) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, render_product_same(is_clickable), Product_Print && render_product_print, Product_Ebook && render_product_ebook);
    };
    return Is_ListItem ? /*#__PURE__*/ React.createElement("div", {
        className: "PRODUCT"
    }, render_product(false)) : render_product(true);
};
var Comp_Cart = function Comp_Cart(props) {
    var _props$Vendor_Hash;
    // - Initialization - //
    var cart_available = props.Cart.filter(function (product) {
        return product.Is_Available;
    }); // Constants //
    var KASSE_URL_USER = props.User_Hash ? '/' + props.User_Hash : '';
    var KASSE_URL_TYPE = props.User_Hash ? 'checkout/0' : 'purchase';
    var KASSE_URL_BASE = "https://app.monsum.com/" + KASSE_URL_TYPE + "/" + ((_props$Vendor_Hash = props.Vendor_Hash) !== null && _props$Vendor_Hash !== void 0 ? _props$Vendor_Hash : props.Base_Item.Vendor_Hash) + KASSE_URL_USER + "/"; // State //
    var _React$useState = React.useState(false), show_modal = _React$useState[0], set_modal = _React$useState[1]; // Misc. //
    var cart_total = cart_available.reduce(function (p, c) {
        return p + c.Brutto_Price;
    }, 0); // - Render - //
    return /*#__PURE__*/ React.createElement("div", {
        className: "CART"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "CART_Icon " + (cart_available.length ? 'ACTIVE' : ''),
        onClick: function onClick() {
            return set_modal(true);
        }
    }, /*#__PURE__*/ React.createElement("img", {
        className: "CART_Icon_Image",
        src: "https://cdn-icons-png.flaticon.com/512/34/34568.png"
    }), cart_available.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "CART_Icon_Count"
    }, cart_available.length)), /*#__PURE__*/ React.createElement("div", {
        className: "CART_Wrapper " + (show_modal ? 'ACTIVE' : ''),
        onClick: function onClick() {
            return set_modal(!show_modal);
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "CART_Modal " + (show_modal ? 'ACTIVE' : '')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "CART_Modal_Header"
    }, "Ihre Warenkorb:"), /*#__PURE__*/ React.createElement("div", {
        className: "CART_Modal_List"
    }, cart_available.map(function (product) {
        return /*#__PURE__*/ React.createElement(Comp_Product, {
            Product: product,
            fxn_click: props.fxn_cart,
            Is_ListItem: true
        });
    })), /*#__PURE__*/ React.createElement("div", {
        className: "CART_Modal_Total"
    }, "Zwischensumme:", /*#__PURE__*/ React.createElement("br", null), toEuroString(cart_total)), /*#__PURE__*/ React.createElement("a", {
        className: "CART_Modal_Order",
        target: "_blank",
        href: "" + KASSE_URL_BASE + props.Base_Item.Code + "&" + cart_available.map(function (item) {
            return "addonQuantity[" + item.Code + "]=1";
        }).join('&')
    }, "Zur Kasse")));
};
var Comp_Shop = function Comp_Shop(props) {
    // - Initialization - //
    var list_item_id = props.List_Item.map(function (item) {
        return item.ID;
    }).filter(function (item_id, idx, arr) {
        return arr.indexOf(item_id) == idx;
    });
    var list_item_pair = list_item_id.map(function (item_id) {
        return {
            print: props.List_Item.find(function (item) {
                return item.ID == item_id && !item.Is_Digital;
            }),
            ebook: props.List_Item.find(function (item) {
                return item.ID == item_id && item.Is_Digital;
            })
        };
    });
    var _useAnalytics = useAnalytics(), trackShopItemSelected = _useAnalytics.trackShopItemSelected; // - Render - //
    var render_item = function render_item(item) {
        var in_cart = props.Cart.includes(item);
        return /*#__PURE__*/ React.createElement("div", {
            key: "shop_" + props.Base_Item.Code + "_" + item.ID,
            className: "SHOP_Item " + (in_cart ? 'PENDING' : '') + " " + (!item.Is_Available ? 'UNAVAILABLE' : '')
        }, /*#__PURE__*/ React.createElement(Comp_Product, {
            Product: item,
            fxn_click: item.Is_Available ? props.fxn_cart : undefined,
            key: props.Base_Item.Code + '_' + item.Code
        }), /*#__PURE__*/ React.createElement("div", {
            className: "SHOP_Item_Buy " + (in_cart ? 'PENDING' : '') + " " + (!item.Is_Available ? 'UNAVAILABLE' : ''),
            "aria-disabled": !item.Is_Available,
            onClick: item.Is_Available ? function () {
                props.fxn_cart(item);
                trackShopItemSelected(item.Title);
            } : undefined
        }, !item.Is_Available ? 'Noch nicht verfügbar' : in_cart ? 'Im Warenkorb' : 'Zum Warenkorb hinzufügen'));
    };
    var render_item_pair = function render_item_pair(item_print, item_ebook) {
        var is_singleton = !(item_print && item_ebook);
        var product_base = !item_print && item_ebook ? item_ebook : item_print;
        if (is_singleton)
            return render_item(product_base);
        var in_cart_print = item_print && props.Cart.includes(item_print);
        var in_cart_ebook = item_ebook && props.Cart.includes(item_ebook);
        var is_available = item_print.Is_Available || item_ebook.Is_Available;
        return /*#__PURE__*/ React.createElement("div", {
            key: "shop_" + props.Base_Item.Code + "_" + product_base.ID,
            className: "SHOP_Item " + (in_cart_print || in_cart_ebook ? 'PENDING' : '') + " " + (!is_available ? 'UNAVAILABLE' : '')
        }, /*#__PURE__*/ React.createElement(Comp_Product_Pair, {
            Product_Print: item_print,
            Product_Ebook: item_ebook,
            fxn_click: product_base.Is_Available ? props.fxn_cart : undefined,
            key: props.Base_Item.Code + '_' + item_print.ID
        }), /*#__PURE__*/ React.createElement("div", {
            className: "SHOP_Item_Buy " + (in_cart_print ? 'PENDING' : '') + " " + (!item_print.Is_Available ? 'UNAVAILABLE' : '') + " PRINT",
            "aria-disabled": !item_print.Is_Available,
            onClick: item_print.Is_Available ? function () {
                props.fxn_cart(item_print);
                trackShopItemSelected(item_print.Title);
            } : undefined
        }, !item_print.Is_Available ? 'Noch nicht verfügbar' : in_cart_print ? 'Im Warenkorb' : 'Zum Warenkorb hinzufügen'), /*#__PURE__*/ React.createElement("div", {
            className: "SHOP_Item_Buy " + (in_cart_ebook ? 'PENDING' : '') + " " + (!item_ebook.Is_Available ? 'UNAVAILABLE' : '') + " EBOOK",
            "aria-disabled": !item_ebook.Is_Available,
            onClick: item_ebook.Is_Available ? function () {
                props.fxn_cart(item_ebook);
                trackShopItemSelected(item_ebook.Title);
            } : undefined
        }, !item_ebook.Is_Available ? 'Noch nicht verfügbar' : in_cart_ebook ? 'Im Warenkorb' : 'Zum Warenkorb hinzufügen'));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "SHOP"
    }, list_item_pair.map(function (item_pair) {
        return render_item_pair(item_pair.print, item_pair.ebook);
    }));
};
var Comp_Store = function Comp_Store(props) {
    // - Initialization - //
    var _React$useState2 = React.useState(true), is_open = _React$useState2[0], set_open = _React$useState2[1]; // - Render - //
    return /*#__PURE__*/ React.createElement("div", {
        className: "STORE",
        key: props.Base_Item.Code
    }, /*#__PURE__*/ React.createElement("div", {
        className: "STORE_Head",
        key: props.Base_Item.Code + '_head'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "STORE_Head_Label",
        key: props.Base_Item.Code + '_head_label',
        onClick: function onClick() {
            return set_open(!is_open);
        }
    }, props.Base_Item.Title), /*#__PURE__*/ React.createElement(Comp_Cart, {
        key: props.Base_Item.Code + '_cart',
        Vendor_Hash: props.Vendor_Hash,
        User_Hash: props.User_Hash,
        Base_Item: props.Base_Item,
        List_Item: props.List_Item,
        Cart: props.Cart,
        fxn_cart: props.fxn_cart
    })), is_open && /*#__PURE__*/ React.createElement(Comp_Shop, {
        key: props.Base_Item.Code + '_shop',
        Base_Item: props.Base_Item,
        List_Item: props.List_Item,
        Cart: props.Cart,
        fxn_cart: props.fxn_cart
    }));
}; /// === PAGE DEFINITION === ///
var JuunitPage = function JuunitPage(_ref6) {
    var data = _ref6.data;
    // - Parse Props - //
    //const list_author: DATOCMS_AUTHOR[] = data.allDatoCmsAuthor.nodes;
    //const list_book: DATOCMS_BOOK[] = list_author.flatMap( author => author.books.map( book => { return { ...book, author: author.name } } ) );
    // - Initialization - //
    // Constants //
    //const monsum_code_makroskop	= '4460bb04b8e54b22c4ed9b836eca00e5';	// TODO: Hide this //
    //const monsum_code_user		= '0898d14b83ff433eb255536365955fcd';	// TODO: Get this from logged in customer //
    var localstorage_key = 'makroskop_webshop'; // State //
    var _React$useState3 = React.useState([]), list_product = _React$useState3[0], set_list_product = _React$useState3[1];
    var _React$useState4 = React.useState({}), cart = _React$useState4[0], set_cart = _React$useState4[1];
    var _React$useState5 = React.useState({
        user: undefined,
        vendor: undefined
    }), dict_hash = _React$useState5[0], set_hashes = _React$useState5[1]; // Context //
    var _React$useContext$ = React.useContext(AuthContext)[0], authenticated = _React$useContext$.authenticated, user = _React$useContext$.user; // Function Definitions //
    var _fxn_cart = function fxn_cart(key, product) {
        var _cart$key, _Object$assign, _cart$key2, _Object$assign2;
        // Update the cart, toggling the current product //
        if (!product.Is_Available)
            return;
        var cart_new = ((_cart$key = cart[key]) !== null && _cart$key !== void 0 ? _cart$key : []).includes(product) ? Object.assign({}, cart, (_Object$assign = {}, _Object$assign[key] = cart[key].filter(function (prod) {
            return prod != product;
        }), _Object$assign)) : Object.assign({}, cart, (_Object$assign2 = {}, _Object$assign2[key] = [].concat(_toConsumableArray((_cart$key2 = cart[key]) !== null && _cart$key2 !== void 0 ? _cart$key2 : []), [product]), _Object$assign2)); //console.log( 'cart_new', cart_new );
        // Update the state and localstorage //
        set_cart(cart_new);
        localStorage.setItem(localstorage_key, JSON.stringify(Object.fromEntries(Object.entries(cart_new).map(function (_ref7) {
            var key = _ref7[0], list_prod = _ref7[1];
            return [key, list_prod.map(function (prod) {
                    return prod.Code;
                })];
        }))));
    };
    var _fxn_cart_clear = function fxn_cart_clear() {
        return localStorage.removeItem(localstorage_key);
    };
    var fxn_init = function fxn_init(list_prod) {
        var _localStorage$getItem;
        // Set react state //
        set_list_product(list_prod); // Load cart from localStorage //
        var storage_cart = JSON.parse((_localStorage$getItem = localStorage.getItem(localstorage_key)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'null'); //console.log( 'storage_cart', storage_cart );
        var list_prod_cart = storage_cart ? Object.entries(storage_cart).map(function (_ref8) {
            var key = _ref8[0], list_prod_code = _ref8[1];
            return [key, list_prod_code.map(function (prod_code) {
                    return list_prod.find(function (prod) {
                        return prod.Code == prod_code;
                    });
                }).filter(function (product) {
                    return product != undefined && product.Is_Available;
                })];
        }) : [];
        set_cart(Object.fromEntries(list_prod_cart));
    };
    var fxn_sort = function fxn_sort(a, b) {
        return a.Sort_Order != b.Sort_Order ? a.Sort_Order - b.Sort_Order : a.Code.toLowerCase() == b.Code.toLowerCase() ? 0 : a.ID.toLowerCase() == b.ID.toLowerCase() ? a.Code.toLowerCase() > b.Code.toLowerCase() ? 1 : -1 : a.ID.toLowerCase() > b.ID.toLowerCase() ? 1 : -1;
    }; // Effects //
    React.useEffect(function () {
        getAccount().then(function (resp) {
            var _resp_data$actionUrls;
            var resp_data = resp.data;
            if ((_resp_data$actionUrls = resp_data.actionUrls) !== null && _resp_data$actionUrls !== void 0 && _resp_data$actionUrls.changeData) {
                // This either sets both or none //
                var action_url = resp_data.actionUrls.changeData;
                var list_hash = action_url.split('/').slice(-2); //console.log( 'accountOverview', action_url, list_hash );
                set_hashes({
                    vendor: list_hash[0],
                    user: list_hash[1]
                });
            }
        }).catch(function (err) {
            console.error('getAccount( )');
            console.error(err);
        });
    }, [authenticated]);
    React.useEffect(function () {
        var get_data_from_cache = function get_data_from_cache() {
            // Read from cache - this shouldn't be in production code! //
            //console.log( '=== READING MONSUM ARTICLES FROM CACHE ===' );
            var list_article = MONSUM_CACHE_ARTICLE;
            var list_book = MONSUM_CACHE_BOOK; //console.table( list_article );
            //console.table( list_book );
            fxn_init([].concat(_toConsumableArray(list_article), _toConsumableArray(list_book)));
        }; // Get product data //
        if (!USE_LIVE_DATA) {
            get_data_from_cache();
            return;
        }
        switch (window.location.hostname) {
            // Production: Firebase Command //
            case 'makroskop.eu':
                {
                    getArticles().then(function (resp) {
                        console.log(resp); // We actually don't know how this will look like! //
                    }).catch(function (err) {
                        //console.error( 'getArticles( )' );
                        console.error(err);
                        get_data_from_cache();
                    });
                    break;
                }
            // Dev: localhost workaround //
            case 'localhost':
                {
                    // Initialization //
                    var LIMIT_MONSUM = 100;
                    var flag_finished = false; // XHR //
                    try {
                        //console.log( '=== LOADING MONSUM ARTICLES ===' );
                        var xhr = new XMLHttpRequest();
                        (function loop(pg, pg_max, result) {
                            if (pg_max === void 0) {
                                pg_max = 10;
                            }
                            if (result === void 0) {
                                result = [];
                            }
                            // Sanity Check //
                            if (pg >= pg_max || flag_finished) {
                                /*console.log( 'End of Database' );*/
                                fxn_init(result);
                                return;
                            } // Setup XHR //
                            xhr.open('POST', "http://localhost:5001/makroskop-b14f3/europe-west1/getArticles");
                            xhr.setRequestHeader('Content-Type', 'application/json');
                            xhr.onreadystatechange = function () {
                                // When the request succeeds and is ready //
                                //console.log( 'xhr.readyState' );
                                if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                                    var _result;
                                    // Collect the response and build the product list //
                                    var resp = JSON.parse(xhr.response);
                                    var list_article = resp.result;
                                    var list_article_product = list_article.map(function (article, idx) {
                                        return new PRODUCT(article);
                                    } //, src_image: list_book[ idx ]?.cover.url } )
                                    );
                                    (_result = result).push.apply(_result, _toConsumableArray(list_article_product)); // Check if we're done or not //
                                    flag_finished = list_article.length < LIMIT_MONSUM; // Next call //
                                    //console.log( `> Page ${ pg } (${ result.length } items)` );
                                    loop(pg + 1, pg_max, result);
                                }
                                if (result.length == 0) // something failed //
                                 {
                                    console.error('xhr localhost');
                                    get_data_from_cache();
                                }
                            }; // Send the paginated request //
                            xhr.send(JSON.stringify({
                                data: {
                                    offset: pg * LIMIT_MONSUM
                                }
                            }));
                        })(0);
                    }
                    catch (err) {
                        console.error('xhr localhost');
                        console.error(err);
                        get_data_from_cache();
                    }
                    break;
                }
            default:
                get_data_from_cache();
        }
    }, [USE_LIVE_DATA]); // Miscellaneous //
    var list_product_article = list_product.filter(function (product) {
        return !product.Is_Addon;
    }).sort(fxn_sort);
    var list_product_addon = list_product.filter(function (product) {
        return product.Is_Addon;
    }).sort(fxn_sort);
    var dict_product = Object.fromEntries(list_product_article.map(function (product_article) {
        return [product_article.Code, list_product_addon.filter(function (product_addon) {
                var _product_addon$List_A;
                return ((_product_addon$List_A = product_addon.List_Article_Code) !== null && _product_addon$List_A !== void 0 ? _product_addon$List_A : []).includes(product_article.Code);
            })];
    })); // - Render - //
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "MAKROSKOP online bestellen"
    }), Object.entries(dict_product).filter(function (_ref9) {
        var article_id = _ref9[0], list_addon = _ref9[1];
        return list_addon.length > 0;
    }).map(function (_ref10) {
        var _cart$article_id;
        var article_id = _ref10[0], list_addon = _ref10[1];
        var base_item = list_product_article.find(function (article) {
            return article.Code == article_id;
        });
        return /*#__PURE__*/ React.createElement(Comp_Store, {
            key: 'store_' + article_id,
            Vendor_Hash: dict_hash.vendor,
            User_Hash: dict_hash.user,
            Base_Item: base_item,
            List_Item: list_addon,
            Cart: (_cart$article_id = cart[article_id]) !== null && _cart$article_id !== void 0 ? _cart$article_id : [],
            fxn_cart: function fxn_cart(product) {
                return _fxn_cart(article_id, product);
            },
            fxn_cart_clear: function fxn_cart_clear() {
                return _fxn_cart_clear();
            }
        });
    }));
};
var query = "2448769755"; /// === EXPORTS === ///
export default JuunitPage;
